import { useQuery } from '@tanstack/react-query';

import { getBanners } from '../queries/banner';
import { useAuthStore, useShipToStore } from '../stores';

export const useGetBanners = () => {
  const session = useAuthStore();
  const { selectedShipToId } = useShipToStore();
  return useQuery({
    queryKey: ['Banners'],
    queryFn: () => getBanners(session.access_token, selectedShipToId),
    enabled: !!selectedShipToId,
  });
};
